export function sbmPeopleListingHandler(extraHeight = 40) {
    $ = jQuery;
    var peopleGroup = $('.view-sbm-people .group_people_container');
    const $container = $("html,body");
    var headerHeight = $('.mtpc_header').height() + extraHeight;
    peopleGroup.each(function () {
        var thisGroup = $(this);
        var headingDiv = thisGroup.find('.group_heading');
        var headingH3 = thisGroup.find('.group_heading > h3');
        var contentWrap = thisGroup.find('.group_content_container');
        var content = thisGroup.find('.group_content');
        if (content.find('.p_img:not(.noImage) > img').length > 0) {
            content.find('.p_img').addClass('rowHasImages');
        }
        headingH3.once().on('click', function () {
            if (content.is(':visible')) {
                contentWrap.slideUp(function () {
                    content.removeClass('expanded').addClass('collapsed');
                    contentWrap.removeClass('expanded').addClass('collapsed');
                    headingDiv.removeClass('expanded').addClass('collapsed');
                    thisGroup.removeClass('expanded').addClass('collapsed');
                    headingH3.removeClass('expanded').addClass('collapsed');
                });
            } else {
                contentWrap.slideDown();
                thisGroup.removeClass('collapsed').addClass('expanded');
                headingDiv.removeClass('collapsed').addClass('expanded');
                headingH3.removeClass('collapsed').addClass('expanded');
                contentWrap.removeClass('collapsed').addClass('expanded');
                content.removeClass('collapsed').addClass('expanded');
            }
        });
    });
    $(window).once().bind("load", function () {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('expandList')) {
            const scrollToClass = '.' + searchParams.get('expandList');
            const $scrollTo = $(scrollToClass);
            if ($scrollTo.length) {
                const contentWrap = $scrollTo.find('.group_content_container');
                const headingDiv = $scrollTo.find('.group_heading');
                const headingH3 = $scrollTo.find('.group_heading > h3');
                const content = $scrollTo.find('.group_content');
                $container.animate({scrollTop: $scrollTo.offset().top - headerHeight}, 800);
                contentWrap.slideDown();
                $scrollTo.removeClass('collapsed').addClass('expanded');
                headingDiv.removeClass('collapsed').addClass('expanded');
                headingH3.removeClass('collapsed').addClass('expanded');
                contentWrap.removeClass('collapsed').addClass('expanded');
                content.removeClass('collapsed').addClass('expanded');
            }
        }
        if (searchParams.has('navigateTo')) {
            const scrollToClass = 'a[name="' + searchParams.get('navigateTo') + '"]';
            const $scrollTo = $(scrollToClass);
            if ($scrollTo.length) {
                $container.animate({scrollTop: $scrollTo.offset().top - headerHeight}, 800);
            }
        }
    });
}
